import { DateRangePicker } from '@panwds/react-ui';
import { format } from 'date-fns';
import React from 'react';
import { useFilters } from '../../hooks/index.js';
import { BaseDateFilter } from './BaseDateFilter.js';
export const timeFormat = (time) => {
    return format(new Date(time), 'PPp');
};
/**
 * Provides a filter with a custom option that allows selecting a time range.
 *
 * Pass items via context in your filter config to provide extra options in the dropdown.
 * All extra props passed via context will be passed to the DateRangePicker.
 */
export const DateRangeFilter = ({ initialDateRangeFromFilter = (filterValue) => {
    if (typeof filterValue === 'boolean' ||
        typeof filterValue === 'string' ||
        typeof filterValue === 'number' ||
        Array.isArray(filterValue))
        return;
    if (filterValue?.['start'] === undefined || filterValue === undefined)
        return;
    const { start, end } = filterValue;
    return {
        start: new Date(`${start}`),
        end: new Date(`${end}`)
    };
}, onCustomApply = (date) => {
    return {
        start: date.start.toISOString(),
        end: date.end.toISOString()
    };
}, customLabel = (filters) => {
    const startLabel = timeFormat(filters.start);
    const endLabel = timeFormat(filters.end);
    return `${startLabel} - ${endLabel}`;
}, id = 'date-range-filter', selectProps, ...rest }) => {
    const { filters } = useFilters();
    const initialDateRange = initialDateRangeFromFilter?.(filters[rest.name]);
    return (React.createElement(BaseDateFilter, { ...rest, selectProps: selectProps, customLabel: customLabel, Picker: React.createElement(DateRangePicker, { initialDateRange: initialDateRange, initialActiveDate: initialDateRange?.start, onApply: onCustomApply }), id: id }));
};
//# sourceMappingURL=DateRangeFilter.js.map